import InnerHeader from "component/shared/innerheader/InnerHeader";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon";
import "./data.scss";
import { useIntl } from "react-intl";
import { END_POINTS } from "constants/APIConstant";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { API_BASE_URL } from "configs/AppConfig";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

function DataDetails() {
  const { id, subId } = useParams();

  const intl = useIntl();
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const dir = useSelector(({ theme }) => theme.direction);

  const imgTest = process.env.PUBLIC_URL + "/image/info1.png";
  const prim = process.env.PUBLIC_URL + "/image/pirm.png";

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const goToBack = () => {
    window.history.go(-1);
  };

  const [indicatorFilterText, setIndicatorFilterText] = useState("");
  // var [txt, setTxt] = useState('')

  const dataFetching = useSWR({
    url: `${END_POINTS.SUBJECT_DETAILS}/${subId}`,
  });

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: `/data/mainSubject/:id/subSubject/:subId`,
      title: `Main Subject: ${dataFetching?.data?.data?.mainSubject?.title} - Sub Subject: ${dataFetching?.data?.data?.title}`,
    });
  }, [id]);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // React.useEffect(() => {
  //   setExpanded(`panel${0}`);
  // }, []);

  const renderData = () => {
    const publicationIndicatorsData =
      dataFetching.error ||
      dataFetching.isLoading ||
      dataFetching.data === undefined ||
      dataFetching.data.data === undefined
        ? []
        : dataFetching.data.data.publicationWithIndicators;
    const rendering =
      Object.keys(publicationIndicatorsData).length > 0 ? (
        <>
          {publicationIndicatorsData
            .filter(
              (x) =>
                x.indicators.filter((x) =>
                  x.name
                    ?.toLowerCase()
                    .includes(indicatorFilterText.toLowerCase())
                )?.length > 0 ||
                x.indicators?.filter((x) =>
                  x.indicatorTranslations[0]?.name
                    ?.toLowerCase()
                    .includes(indicatorFilterText.toLowerCase())
                )?.length > 0
            )
            .map(({ name, publicationTranslations, indicators }, i) => {
              return (
                <Accordion
                  className="mb-3 shadow"
                  expanded={expanded === `panel${i}`}
                  onChange={handleChange(`panel${i}`)}
                  key={i}
                >
                  <AccordionSummary
                    aria-controls={`panel${i}bh-content`}
                    id={`panel${i}bh-header`}
                    className={"accordions-summary"}
                  >
                    <div
                      className={`icon ${
                        expanded === `panel${i}` ? "open" : "close"
                      }`}
                    >
                      <i className="fas fa-minus"></i>
                      <i className="fas fa-plus"></i>
                    </div>
                    <h5>
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: name,
                        translations: publicationTranslations,
                      })}
                    </h5>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ textAlign: "start", paddingInlineStart: "2rem" }}
                    className="py-3 row justify-content-end"
                  >
                    {/* <div className="col-md-6 col-9">
                                        <input
                                            className='form-control mb-3' 
                                            type="search" 
                                            name={`search-panel${i}`} 
                                            id={`search-panel${i}`} 
                                            placeholder={`${intl.formatMessage({ id: "search-indicator-name" })}`}
                                        />
                                    </div> */}
                    <div className="col-12">
                      {indicators
                        .filter(
                          (x) =>
                            x.name
                              ?.toLowerCase()
                              .includes(indicatorFilterText.toLowerCase()) ||
                            x.indicatorTranslations[0]?.name
                              ?.toLowerCase()
                              .includes(indicatorFilterText.toLowerCase())
                        )
                        .map((indicator, i) => (
                          <Link
                            key={i}
                            to={`/data/mainSubject/${id}/subSubject/${subId}/data-visualization/${indicator?.indicatorId}`}
                          >
                            <ChevronIcon
                              width={20}
                              height={12}
                              color={`#1F254B`}
                            />
                            <span style={{ color: "#1F254B" }}>
                              <LabelLang
                                id="name"
                                defaultValue={indicator?.name}
                                translations={indicator?.indicatorTranslations}
                              />
                            </span>
                          </Link>
                        ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  return (
    <ContentLoading
      isLoading={
        // dataFetching.error ||
        dataFetching.isLoading
      }
    >
      <div className="data-details">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "data" }),
              clickClass: false,
            },
            {
              title: (
                <LabelLang
                  id="title"
                  defaultValue={dataFetching?.data?.data?.title}
                  translations={dataFetching?.data?.data?.subjectTranslations}
                />
              ),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "data-title" })}
          route={"../data"}
        />
        {dataFetching.error ?
          <div className="container my-5">
            <h5 className="text-center text-danger fw-bold">{intl.formatMessage({ id: "timeout-error" })}</h5>
          </div>
          :
          <div className="container mt-5 mb-3">
            <div className="title-item row g-2">
              <div className="col-xl-9 col-md-8">
                <h4
                  style={{
                    color: "var(--main-color)",
                    textShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <LabelLang
                    id="title"
                    defaultValue={dataFetching?.data?.data?.mainSubject?.title}
                    translations={
                      dataFetching?.data?.data?.mainSubject?.subjectTranslations
                    }
                  />
                </h4>
              </div>
              <div className="col-xl-3 col-md-4">
                <input
                  className="form-control"
                  type="search"
                  name="search"
                  id="search"
                  placeholder={`${intl.formatMessage({
                    id: "search-indicator-name",
                  })}`}
                  onChange={(e) => {
                    setIndicatorFilterText(e.target.value);
                    if(e.target.value) {
                      setExpanded(`panel${0}`);
                    }
                    else {
                      setExpanded(``);
                    }
                  }}
                />
              </div>
            </div>
            <div className="row gx-0 gx-md-4 gy-4 gy-md-0 d-flex justify-content-center">
              <div className="col-lg-4 col-md-5 col-11">
                <div className="img-details">
                  <img
                    src={
                      dataFetching?.data?.data?.mainSubject?.image
                        ? `${API_BASE_URL}/${dataFetching?.data?.data?.mainSubject?.image}`
                        : imgTest
                    }
                    alt="img-details"
                  />
                  <button className="learn-more" onClick={goToBack}>
                    <span
                      className="circle"
                      style={{ background: "var(--main-color)" }}
                      aria-hidden="true"
                    >
                      <span className={`icon arrow ${dir}`}></span>
                    </span>
                    <span
                      className="button-text"
                      style={{ color: "var(--main-color)" }}
                    >
                      {intl.formatMessage({ id: "back-to-browse-topics" })}
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-8 col-md-7 col-11">
                <div
                  className="group-links"
                  style={{ borderInlineStartColor: "var(--main-color)" }}
                >
                  <div className="main-title">
                    <h4>
                      {/* {`${intl.formatMessage({ id: "indicators-data" })}`}{" "} */}
                      <LabelLang
                        id="title"
                        defaultValue={dataFetching?.data?.data?.title}
                        translations={
                          dataFetching?.data?.data?.subjectTranslations
                        }
                      />
                    </h4>
                  </div>
                  <div className="links-list">{renderData()}</div>
                  <div className="img-data-fixed">
                    <img src={prim} alt="img-data-fixed" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </ContentLoading>
  );
}

export default DataDetails;
